export default function AkwabaSafety() {
    return <div className="relative bg-blue w-10 h-10 overflow">
        <div>
        <img src="/images/AKWABA-Safely.png" alt="AKWABA Safety" width={1000} height={1000} className="w-10 h-10 hover:scale-[6] hover:translate-y-[2.5rem] hover:inline-block cursor-pointer absolute top-0 left-0 transition-all duration-300" />
        </div>
    </div>
}
